import SiafLiteApiRepository from "../../external/siafLiteApi";

class MdfeMunicipiosCarregamentoService {
  constructor() {
    this.urlBase = "/faturamento/mdfe-municipio-carregamento";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }
}

export default MdfeMunicipiosCarregamentoService;
